// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2895 ? "online-order-page" : chunkId) + "." + {"2895":"b7e63d7e","5218":"64aef506","9124":"63fa5a67"}[chunkId] + ".chunk.css";
};